import {capitalize} from 'lodash';

import fieldsHelper from '@/utils/fields-helper';

export default function(analytics) {
  return {
    trackNavEditProfileClicked() {
      analytics.trackEvent({action: 'Nav Edit Profile Clicked'});
    },

    trackProfileButtonClicked(buttonText) {
      analytics.trackEvent({
        action: `Edit Profile ${capitalize(buttonText)} Clicked`,
        properties: {
          'Button-text': buttonText
        }
      });
    },

    trackProfileValidationError(errors) {
      analytics.trackEvent({
        action: 'Edit Profile Validation Error',
        properties: {
          FieldNames: fieldsHelper.getFieldNames(errors)
        }
      });
    },

    trackProfileAddNewItem(type) {
      analytics.trackEvent({
        action: 'Edit Profile Add New Item',
        properties: {
          type
        }
      });
    },

    trackProfileXClicked(type) {
      analytics.trackEvent({
        action: 'Edit Profile X Clicked',
        properties: {
          type
        }
      });
    },

    trackProfileDeleteExperienceClicked(type) {
      analytics.trackEvent({
        action: 'Edit Profile Delete Experience Clicked',
        properties: {
          type
        }
      });
    },

    trackProfileCancelDeleteExperienceClicked(type) {
      analytics.trackEvent({
        action: 'Edit Profile Cancel Delete Experience Clicked',
        properties: {
          type
        }
      });
    },

    trackProfileCompletenessClick(screens) {
      analytics.trackEvent({
        action: 'Edit Profile completeness click',
        properties: {
          Screens: screens
        }
      });
    },

    trackRequestForRecommendationClick(location, industry, role, title, jobCount, isAfterRegister) {
      analytics.trackEvent({
        action: 'Request for Recommendation',
        properties: {
          Location: location || '',
          Industry: industry || '',
          Role: role || '',
          'Job title': title || '',
          Context: isAfterRegister ? 'questionnaire signup' : 'questionnaire update',
          'Job counts': jobCount
        }
      });
    }
  };
}
